import { createContext, useContext } from 'react';

export type DropdownPlacement =
  | 'top'
  | 'top-start'
  | 'top-end'
  | 'bottom'
  | 'bottom-start'
  | 'bottom-end'
  | 'right'
  | 'right-start'
  | 'right-end'
  | 'left'
  | 'left-start'
  | 'left-end';

export type DropdownOptions = {
  placement?: DropdownPlacement;
  closeOnClick?: boolean;
};

export type DropdownContextValue = {
  active: boolean;
  open: () => void;
  close: () => void;
  placement: DropdownPlacement;
};

const noop = () => {};
export const DropdownContext = createContext<DropdownContextValue>({
  active: false,
  open: noop,
  close: noop,
  placement: 'bottom',
});

export const useDropdown = () => useContext(DropdownContext);
